<div class="star-wrapper">
  <ng-container *ngFor="let star of [1,2,3,4,5]">
    <div class="star" (click)="onStarClick($event, star)">
      <app-svg-loader height="20px" url="assets/svg/star-solid.svg" [ngStyle]="{opacity: star <= rating ? 1 : 0.3}"></app-svg-loader>
    </div>
  </ng-container>
</div>
